const EMERGENCIAS = [
  { numero: '109', nombre: 'Emergencias' },
  { numero: '911', nombre: 'Policía' },
  { numero: '144', nombre: 'Violencia de género' },
];

/** Pie con los mismos datos que www.lujan.gob.ar. */
export function Pie() {
  return (
    <footer className="pie">
      <div className="contenedor">
        <ul className="pie__emergencias" aria-label="Teléfonos de emergencia">
          {EMERGENCIAS.map((e) => (
            <li key={e.numero}>
              <a href={`tel:${e.numero}`}>
                <span className="pie__numero">{e.numero}</span>
                <span className="pie__servicio">{e.nombre}</span>
              </a>
            </li>
          ))}
        </ul>
        <div className="pie__datos">
          <img src="/img/logo-lujan.png" alt="Municipalidad de Luján" width={121} height={38} />
          <address>
            San Martín 550 (CP 6700), Luján, provincia de Buenos Aires
            <br />
            <a href="mailto:contacto@lujan.gob.ar">contacto@lujan.gob.ar</a>
          </address>
          <p className="pie__nota">
            Las normas tienen validez según su publicación oficial en PDF. Consultas sobre este sitio:{' '}
            <a href="mailto:desarrollo@lujan.gov.ar">desarrollo@lujan.gov.ar</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
